import React, { useCallback } from 'react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import './AnimatedBackground.css';

const AnimatedBackground = ({ children, className = "" }) => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesOptions = {
    background: {
      color: {
        value: '#ffffff',
      },
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: 'repulse',
        },
        resize: true,
      },
      modes: {
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: ['#132a13', '#31572c', '#4f772d', '#90a955'],
      },
      links: {
        enable: false,
      },
      collisions: {
        enable: false,
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 0.5,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 1000,
        },
        value: 40,
      },
      opacity: {
        value: { min: 0.1, max: 0.5 },
        animation: {
            enable: true,
            speed: 1,
            sync: false
        }
      },
      shape: {
        type: ['circle', 'triangle', 'polygon'],
         polygon: {
          sides: 5
        }
      },
      size: {
        value: { min: 1, max: 5 },
      },
    },
    detectRetina: true,
  };

  return (
    <div className={`animated-background-container ${className}`}>
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={particlesOptions}
            className="tsparticles-canvas"
        />
        <div className="animated-background-content">
            {children}
        </div>
    </div>
  );
};

export default AnimatedBackground;
